import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { useData } from "../../../../components/firebase/DataProvider";
import {
  firefunctions,
  firestore,
  storage,
} from "../../../../components/firebase/FirebaseProvider";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import { useSnackbar } from "notistack";
import DateFnsUtils from "@date-io/date-fns";
import Header from "../../../../components/molecules/Header";
import Gap from "../../../../components/Gap";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Divider from "@material-ui/core/Divider";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Typography from "@material-ui/core/Typography";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import BelumTersedia from "../../../../assets/icon/BelumTersedia.js";
import { nikParser } from "nik-parser";
import AlamatDialog from "../../Alamat/AlamatDialog";
import { convertDateOnly } from "../../../../utils/dateTime";
import VerifyStatus from "./verifyStatus";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Radio from "@material-ui/core/Radio";
import useStyles from "./style";
import { DialogTitle, IconButton } from "@material-ui/core";
const defaultLogo = require("../../../../assets/images/landing-image-third.png");

function ListAlamat({
  open,
  closeList,
  alamat,
  profil,
  setForm,
  form,
  setError,
  error,
}) {
  const [selectedAlamat, setSelectedAlamat] = useState({});

  const [dialog, setDialog] = useState({
    open: false,
    action: "",
  });

  const { enqueueSnackbar } = useSnackbar();

  const handlePilihAlamat = async (item) => {
    try {
      await setForm({ ...form, alamat_domisili: item });
      setError({ ...error, alamat_domisili: "" });
      setSelectedAlamat(item);
      enqueueSnackbar("Alamat Berhasil Dipilih", {
        variant: "success",
      });
      closeList();
    } catch (e) {
      console.log(e.message);
    }
  };
  return (
    <>
      <Dialog
        open={open}
        onClose={closeList}
        fullScreen
        PaperProps={{
          style: { maxWidth: 960 },
        }}
      >
        <DialogTitle>
          <div style={{ display: "flex", alignItems: "center" }}>
            <IconButton
              size="small"
              onClick={closeList}
              style={{ marginRight: 15 }}
            >
              <ArrowBackIcon />
            </IconButton>
            <Typography>Pilih Alamat</Typography>
          </div>
        </DialogTitle>
        {/* <div style={{ paddingTop: "40px" }}> */}
        <DialogContent dividers style={{ padding: "10px" }}>
          <List>
            <Button
              fullWidth
              variant="outlined"
              color="primary"
              // disabled={loading}
              onClick={() => setDialog({ open: true, action: "add" })}
            >
              Tambah Alamat
            </Button>
            <Gap height={20} />
            {alamat?.length > 0 ? (
              alamat?.map((item) => {
                return (
                  <ListItem button onClick={() => handlePilihAlamat(item)}>
                    <ListItemText
                      primary={
                        <>
                          <Typography
                            style={{ display: "inline" }}
                            color="textPrimary"
                          >
                            {item.nama_penerima}
                          </Typography>
                          <Typography
                            style={{ display: "inline" }}
                            color="error"
                          >
                            {"     "}{" "}
                            {profil?.alamat_utama === item.id ? "[Utama]" : ""}
                          </Typography>
                        </>
                      }
                      secondary={
                        <React.Fragment>
                          {`${item.alamat_lengkap}, ${item.kecamatan.name}, ${item.kelurahan.name}, ${item.kota.name}`}
                        </React.Fragment>
                      }
                    />
                    <ListItemSecondaryAction>
                      <Radio
                        edge="end"
                        // disabled={loading}
                        // onClick={() => console.log(item)}
                        checked={selectedAlamat.id === item.id ? true : false}
                        // inputProps={{ 'aria-labelledby': labelId }}
                      />
                    </ListItemSecondaryAction>
                  </ListItem>
                );
              })
            ) : (
              <div>
                <p>Tidak ada data</p>
              </div>
            )}
          </List>
          {/* <Gap height={50} /> */}
        </DialogContent>
        {/* </div> */}
      </Dialog>
      <AlamatDialog
        open={dialog.open}
        handleClose={() =>
          setDialog({
            open: false,
          })
        }
      />
    </>
  );
}

function BelumTersediaScreen() {
  const classes = useStyles();

  return (
    <Container>
      <div
        style={{
          paddingTop: "150px",
        }}
      >
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <BelumTersedia />
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidPrimary}>
              Fitur belum tersedia
            </Typography>
          </Grid>
          <Grid item xs={12} className={classes.warpText}>
            <Typography className={classes.liquidSecondary}>
              Verifikasi KTP adalah fitur untuk memudahkan kamu dalam melakukan
              pencairan & transaksi kedepanya.
            </Typography>
          </Grid>
        </Grid>
      </div>
    </Container>
  );
}

function Verifikasi() {
  const classes = useStyles();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const {
    phone,
    profil,
    webstore,
    alamat,
    verifikasiData,
    list_pekerjaan,
    global_settings,
  } = useData();
  const [openList, setOpenList] = useState(false);
  const [currentName] = useState(profil.nama);
  const [currentWebstore] = useState({
    domain: `https://${webstore.domain}.tokorame.store`,
  });
  const [form, setForm] = useState({});
  const [error, setError] = useState({
    nama: "",
    nomor: "",
    jenis_kelamin: "",
    tempat_lahir: "",
    alamat_domisili: "",
    alamat: "",
    pekerjaan: "",
    image: "",
  });
  const [selectedDate, handleDateChange] = useState(new Date());
  const [isSubmitting, setSubmitting] = useState(false);
  const [isForm, setIsForm] = useState(false);
  const jenis = [
    { label: "Laki - Laki", values: "L" },
    { label: "Perempuan", values: "P" },
  ];

  const handleChange = (e) => {
    let value = e.target.value;
    if (e.target.type === "number") {
      value = parseInt(value);
    }
    setSubmitting(false);
    setForm({
      ...form,
      [e.target.name]: value,
    });
    // console.log(form)

    setError({
      ...error,
      [e.target.name]: "",
    });
  };

  const validate = async () => {
    const newError = { ...error };

    if (!form.nama) {
      newError.nama = "nama harus di isi";
    }
    if (!form.nomor) {
      newError.nomor = `${
        form?.tipe == "KTP" ? "NIK" : `No. ${form?.tipe ? form?.tipe : ""}`
      } harus di isi`;
    }
    if (form.tipe === "KTP") {
      try {
        const nik = nikParser(form?.nomor);
        if (!nik.isValid()) {
          newError.nomor = "nik tidak valid";
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (!form.jenis_kelamin) {
      newError.jenis_kelamin = "jenis kelamin harus di isi";
    }
    if (!form.tempat_lahir) {
      newError.tempat_lahir = "tempat lahir harus di isi";
    }
    if (!form.alamat_domisili) {
      newError.alamat_domisili = "alamat domisili harus di isi";
    }
    if (!form.alamat) {
      newError.alamat = "alamat identitas harus di isi";
    }
    if (!form.pekerjaan) {
      newError.pekerjaan = "pekerjaan harus di isi";
    }
    if (!form.image) {
      newError.image = "image harus di isi";
    }

    return newError;
  };

  const handleSubmit = async (e) => {
    const findError = await validate();
    console.log(findError);
    if (Object.values(findError).some((m) => m !== "")) {
      setError(findError);
    } else {
      setSubmitting(true);
      try {
        const func = firefunctions.httpsCallable("validateKTP");
        const ktpCol = firestore.collection("identifier_number");
        const dataCf = {
          user_id: profil.id,
          nomor: form.nomor,
        };
        const data = {
          nama: form.nama,
          nomor: form.nomor,
          jenis_kelamin: form.jenis_kelamin?.values,
          tempat_lahir: form.tempat_lahir,
          tanggal_lahir: convertDateOnly(selectedDate),
          alamat_domisili: form.alamat_domisili,
          alamat: form.alamat,
          pekerjaan:
            form.pekerjaan === "lainnya"
              ? form.pekerjaanLainnya
              : form.pekerjaan,
          image: form.image,
        };

        const res = await func(dataCf);
        await ktpCol.doc(profil.id).set(data, { merge: true });

        // console.log(dataCf);
        // console.log(data);
        // console.log("res.data", res.data);
        enqueueSnackbar("Data berhasil dimasukan, data akan di tinjau", {
          variant: "success",
        });
        setSubmitting(false);
        setIsForm(false);
      } catch (e) {
        const newError = {};
        newError.title = e.message;

        setError(newError);
        enqueueSnackbar(e.message, {
          variant: "error",
        });
        console.log(e.message);
        setSubmitting(false);
      }
    }
  };

  const handleOpenList = () => {
    setOpenList(true);
  };

  const handleCLoseList = () => {
    setOpenList(false);
  };

  const alamatDom = `${
    form?.alamat_domisili?.provinsi?.name
      ? form?.alamat_domisili?.provinsi?.name
      : ""
  } ${
    form?.alamat_domisili?.kota?.name ? form?.alamat_domisili?.kota?.name : ""
  } ${
    form?.alamat_domisili?.kecamatan?.name
      ? form?.alamat_domisili?.kecamatan?.name
      : ""
  } ${
    form?.alamat_domisili?.kelurahan?.name
      ? form?.alamat_domisili?.kelurahan?.name
      : ""
  } ${
    form?.alamat_domisili?.kelurahan?.postcode
      ? form?.alamat_domisili?.kelurahan?.postcode
      : ""
  }`;

  const handleUploadFile = async (e) => {
    const file = e.target.files[0];

    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      enqueueSnackbar(`Tipe file tidak didukung: ${file.type}`, {
        variant: "error",
      });
      // setError((error) => ({
      //   ...error,
      //   image: `Tipe file tidak didukung: ${file.type}`,
      // }));
    } else if (file.size >= 512000) {
      enqueueSnackbar(`Ukuran file terlalu besar > 500KB`, {
        variant: "error",
      });
      // setError((error) => ({
      //   ...error,
      //   image: `Ukuran file terlalu besar > 500KB`,
      // }));
    } else {
      const reader = new FileReader();

      reader.onabort = () => {
        enqueueSnackbar(`Proses pembacaan file dibatalkan`, {
          variant: "error",
        });
        // setError((error) => ({
        //   ...error,
        //   image: `Proses pembacaan file dibatalkan`,
        // }));
      };

      reader.onerror = () => {
        enqueueSnackbar("File tidak bisa dibaca", {
          variant: "error",
        });
        // setError((error) => ({
        //   ...error,
        //   image: "File tidak bisa dibaca",
        // }));
      };

      reader.onload = async () => {
        setError((error) => ({
          ...error,
          image: "",
        }));
        setSubmitting(true);
        try {
          const ktpStorageRef = storage.ref(`users`);

          const urlExt = file.name.substring(file.name.lastIndexOf("."));

          const urlRef = ktpStorageRef.child(
            `/verifikasi_akun/${profil.id}/${Date.now()}${urlExt}`
          );

          const urlSnapshot = await urlRef.putString(reader.result, "data_url");

          const urlUrl = await urlSnapshot.ref.getDownloadURL();

          setForm((currentForm) => ({
            ...currentForm,
            image: urlUrl,
          }));
        } catch (e) {
          setError((error) => ({
            ...error,
            image: e.message,
          }));
        }

        setSubmitting(false);
      };

      reader.readAsDataURL(file);
    }
  };

  const menuPekerjaan = list_pekerjaan?.judul;

  const tipe = ["KTP", "Passport", "SIM"];

  return (
    <>
      <Header
        type="with-title"
        title="Verifikasi Akun"
        onClick={() => history.goBack()}
      />
      {!global_settings.aktivasi_wajib_verifikasi_akun ? (
        <BelumTersediaScreen />
      ) : verifikasiData === undefined || isForm === true ? (
        <Container>
          <div className={classes.wrapHeader}>
            <div className={classes.wrapAvatar}>
              <Avatar
                className={classes.large}
                src={!webstore.logo ? defaultLogo : webstore.logo}
              />
            </div>
            <Gap width={16} />
            <div>
              <p>{currentName}</p>
              <p>{phone?.id}</p>
              <p>{currentWebstore.domain}</p>
            </div>
          </div>
          <Divider />
          <Gap height={20} />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Autocomplete
                id="tipe"
                name="tipe"
                margin="normal"
                required
                value={form?.tipe ?? []}
                onChange={(event, value) => {
                  handleChange({
                    target: { name: "tipe", value },
                  });
                }}
                disabled={isSubmitting}
                options={tipe}
                getOptionLabel={(option) => option}
                renderInput={(params) => (
                  <TextField
                    helperText={error?.tipe}
                    error={error?.tipe ? true : false}
                    {...params}
                    label="Tipe"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                autoComplete="off"
                disabled={isSubmitting}
                id="nomor"
                name="nomor"
                label={
                  form?.tipe == "KTP"
                    ? "NIK"
                    : `No. ${form?.tipe ? form?.tipe : ""}`
                }
                value={form?.nomor || ""}
                onChange={handleChange}
                error={error?.nomor ? true : false}
                helperText={error?.nomor}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                autoComplete="off"
                disabled={isSubmitting}
                id="nama"
                name="nama"
                label="Nama"
                value={form?.nama || ""}
                onChange={handleChange}
                error={error?.nama ? true : false}
                helperText={error?.nama}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                autoComplete="off"
                disabled={isSubmitting}
                id="tempat_lahir"
                name="tempat_lahir"
                label="Tempat Lahir"
                value={form?.tempat_lahir || ""}
                onChange={handleChange}
                error={error?.tempat_lahir ? true : false}
                helperText={error?.tempat_lahir}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <MuiPickersUtilsProvider utils={DateFnsUtils}>
                <DatePicker
                  fullWidth
                  disabled={isSubmitting}
                  disableFuture
                  openTo="year"
                  format="dd/MM/yyyy"
                  label="Tanggal lahir"
                  views={["year", "month", "date"]}
                  inputVariant="outlined"
                  value={selectedDate}
                  onChange={handleDateChange}
                />
              </MuiPickersUtilsProvider>
            </Grid>
            <Grid item lg={6} xs={12}>
              <Autocomplete
                id="jenis_kelamin"
                name="jenis_kelamin"
                margin="normal"
                required
                value={form?.jenis_kelamin ?? []}
                onChange={(event, value) => {
                  handleChange({
                    target: { name: "jenis_kelamin", value },
                  });
                }}
                disabled={isSubmitting}
                options={jenis}
                getOptionLabel={(option) => option.label}
                renderInput={(params) => (
                  <TextField
                    helperText={error?.jenis_kelamin}
                    error={error?.jenis_kelamin ? true : false}
                    {...params}
                    label="Jenis Kelamin"
                    variant="outlined"
                  />
                )}
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <TextField
                autoComplete="off"
                disabled={isSubmitting}
                id="alamat"
                name="alamat"
                label={`Alamat ${form.tipe === "KTP" ? "KTP" : "Identitas"}`}
                value={form?.alamat || ""}
                onChange={handleChange}
                error={error?.alamat ? true : false}
                helperText={error?.alamat}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item lg={6} xs={12}>
              <FormControl fullWidth variant="outlined">
                <InputLabel id="demo-simple-select-label">Pekerjaan</InputLabel>
                <Select
                  id="pekerjaan"
                  name="pekerjaan"
                  value={form.pekerjaan}
                  onChange={handleChange}
                  disabled={isSubmitting}
                  label="pekerjaan"
                >
                  {menuPekerjaan.map((option) => {
                    return <MenuItem value={option}>{option}</MenuItem>;
                  })}
                  <MenuItem value="lainnya">Lainnya</MenuItem>
                </Select>
              </FormControl>
            </Grid>

            {form.pekerjaan === "lainnya" ? (
              <Grid item lg={6} xs={12}>
                <TextField
                  name="pekerjaanLainnya"
                  label="Pekerjaan Lainnya"
                  fullWidth
                  onChange={handleChange}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={form.pekerjaanLainnya}
                  helperText={error.pekerjaan}
                  error={error.pekerjaan ? true : false}
                  disabled={isSubmitting}
                  autoComplete="off"
                  variant="outlined"
                />
              </Grid>
            ) : null}
            <Grid item lg={6} xs={12}>
              <TextField
                autoComplete="off"
                onClick={handleOpenList}
                disabled={isSubmitting}
                id="alamat_domisili"
                name="alamat_domisili"
                label="Alamat Domisili"
                value={alamatDom || ""}
                error={error?.alamat_domisili ? true : false}
                helperText={error?.alamat_domisili}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12}>
              {form.image && (
                <img
                  src={form.image}
                  className={classes.previewFotoKursus}
                  alt=""
                />
              )}
              <input
                style={{ display: "none" }}
                id="upload-url-akun"
                accept="image/jpeg,image/png,image/jpg"
                name="url"
                type="file"
                onChange={handleUploadFile}
              />
              <label htmlFor="upload-url-akun">
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  fullWidth
                  disabled={isSubmitting}
                >
                  Upload Foto {form?.tipe}
                </Button>
              </label>
              {/* {error?.image && (
                <Typography color="error">{error?.image}</Typography>
              )} */}
            </Grid>
            <Grid item xs={12}>
              <Button
                fullWidth
                variant="contained"
                color="primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting ? "loading" : "Verifikasi"}
              </Button>
            </Grid>
          </Grid>
        </Container>
      ) : (
        <VerifyStatus verifikasiData={verifikasiData} setIsForm={setIsForm} />
      )}
      <ListAlamat
        open={openList}
        alamat={alamat}
        profil={profil}
        closeList={handleCLoseList}
        form={form}
        setForm={setForm}
        setError={setError}
        error={error}
      />
    </>
  );
}

export default Verifikasi;
